import React, { Component } from "react";
import { Modal, Form, Input, Select } from "antd";
import http from "../../../axios/http";

const FormItem = Form.Item;

class ParkZoneEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feeRules: [],
    };
  }

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      http.post({
        url: "/barrier/parkZone/save",
        data: values,
        success: (res) => {
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Modal
        visible={visible}
        title="停车区域信息编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="区域编码：">
            {getFieldDecorator("code", {
              rules: [
                { required: true, message: "请输入编码!" },
                { max: 32, message: "最多只能输入32个字符！" },
              ],
              initialValue: editData.code,
            })(<Input />)}
          </FormItem>
          <FormItem label="区域名称：">
            {getFieldDecorator("name", {
              rules: [
                { required: true, message: "请输入名称!" },
                { max: 32, message: "最多只能输入32个字符！" },
              ],
              initialValue: editData.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="区域类型：">
            {getFieldDecorator("type", {
              initialValue: editData.type || 0,
            })(
              <Select>
                <Select.Option value={0}>社会区域</Select.Option>
                <Select.Option value={1}>交易车</Select.Option>
                <Select.Option value={2}>服务站</Select.Option>
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const ParkZoneEdit = Form.create()(ParkZoneEditForm);

export default ParkZoneEdit;
